import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  GET_PENDING_ACTIVITY_SUMMARY,
  GET_SEATING_ACTIVITY_SUMMARY,
  GET_ALL_SEATING_DASHBOARD_SUMMARY,
  GET_ALL_COUNT_SUMMARY_REPORTS,
  GET_ALL_VENDOR_SEATING_DINER_RECORDS,
  GET_ALL_VENDOR_PENDING_DINER_RECORDS,
  GET_ALL_VENDOR_RESERVATION_DINER_RECORDS,
  GET_ALL_VENDOR_HISTORY_DINER_RECORDS,
} from "../../types";
import { setErrors } from "../errorActions";

/***********************************************
 * @DESC GET PENDING REPORT VENDOR SUMMARY
 **********************************************/
export const admin_get_vendor_pending_summary_r_I =
  (token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_vendor_pending_summary_r_Info = await axios.get(
        `${serverApi}/admin/diner?diner_status=PENDING&all=true`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_vendor_pending_summary_r_Info.status === 200) {
        dispatch({
          type: GET_PENDING_ACTIVITY_SUMMARY,
          payload: get_vendor_pending_summary_r_Info.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***********************************************
 * @DESC GET SEATING REPORT VENDOR SUMMARY
 **********************************************/
export const admin_get_vendor_seating_summary_r_I =
  (token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_vendor_seating_summary_r_Info = await axios.get(
        `${serverApi}/admin/diner?diner_status=SEATING&all=true`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_vendor_seating_summary_r_Info.status === 200) {
        dispatch({
          type: GET_SEATING_ACTIVITY_SUMMARY,
          payload: get_vendor_seating_summary_r_Info.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/********************************************************
 * @DESC GET ALL SEATING DASHBOARD REPORT VENDOR SUMMARY
 *******************************************************/
export const admin_get_all_seating_dashboard_summary_r_I =
  (token, actionBy, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const get_all_seating_dashboard_summary = await axios.get(
        `${serverApi}/admin/diner-request${
          actionBy ? `?startDate=${startDate}&endDate=${endDate}` : ""
        }`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_all_seating_dashboard_summary.status === 200) {
        dispatch({
          type: GET_ALL_SEATING_DASHBOARD_SUMMARY,
          payload: get_all_seating_dashboard_summary.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/********************************************************
 * @DESC GET ALL SUMMARY
 *******************************************************/
export const admin_get_all_request_count =
  (token, actionBy, statusType) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const get_all_request_count = await axios.get(
        `${serverApi}/admin/diner-request-count${
          actionBy ? `?diner_status=${statusType}` : ""
        }`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_all_request_count.status === 200) {
        dispatch({
          type: GET_ALL_COUNT_SUMMARY_REPORTS,
          payload: get_all_request_count.data,
        });
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      // dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_vendor_pending_diner_r_info =
  (token, vendorID) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_vendor_pending_diner_r_Info = await axios.get(
        `${serverApi}/diner?vendor_id=${vendorID}&diner_status=PENDING`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_vendor_pending_diner_r_Info.status === 200) {
        dispatch({
          type: GET_ALL_VENDOR_PENDING_DINER_RECORDS,
          payload: get_vendor_pending_diner_r_Info.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_vendor_seating_diner_r_info =
  (token, vendorID, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_vendor_seating_diner_r_Info = await axios.get(
        `${serverApi}/diner?vendor_id=${vendorID}&diner_status=SEATING`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_vendor_seating_diner_r_Info.status === 200) {
        dispatch({
          type: GET_ALL_VENDOR_SEATING_DINER_RECORDS,
          payload: get_vendor_seating_diner_r_Info.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_vendor_reservation_diner_r_info =
  (token, vendorID, custom_time) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_vendor_reservation_diner_r_Info = await axios.get(
        `${serverApi}/diner?vendor_id=${vendorID}&diner_status=RESERVATION&${
          custom_time === undefined
            ? ""
            : `customTime=${custom_time}` && custom_time === true
            ? `openAll=${custom_time}`
            : `customTime=${custom_time}`
        }`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_vendor_reservation_diner_r_Info.status === 200) {
        dispatch({
          type: GET_ALL_VENDOR_RESERVATION_DINER_RECORDS,
          payload: get_vendor_reservation_diner_r_Info.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_vendor_history_diner_r_info =
  (token, vendorID) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_vendor_history_diner_r_Info = await axios.get(
        `${serverApi}/diner?vendor_id=${vendorID}&diner_status=HISTORY`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_vendor_history_diner_r_Info.status === 200) {
        dispatch({
          type: GET_ALL_VENDOR_HISTORY_DINER_RECORDS,
          payload: get_vendor_history_diner_r_Info.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
